import React from 'react';
import { SkeletonRect, SkeletonText, SkeletonButton, SkeletonPill } from '../../../common/Skeleton';

const SubmissionFormFormSkeleton = () => {
  return (
    <div className="space-y-4">
      {/* Title Input Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-24']} height="h-4" />
        </div>
        <SkeletonRect width="w-full" height="h-10" rounded="md" />
      </div>

      {/* Description Editor Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-32']} height="h-4" />
        </div>
        <SkeletonRect width="w-full" height="h-[200px]" rounded="md" />
      </div>

      {/* Checkboxes Grid Skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex items-center space-x-2">
          <SkeletonRect width="w-4" height="h-4" rounded="sm" />
          <SkeletonText widths={['w-28']} height="h-4" />
        </div>
        <div className="flex items-center space-x-2">
          <SkeletonRect width="w-4" height="h-4" rounded="sm" />
          <SkeletonText widths={['w-32']} height="h-4" />
        </div>
      </div>

      {/* Image Required Checkbox Skeleton */}
      <div className="flex items-center space-x-2">
        <SkeletonRect width="w-4" height="h-4" rounded="sm" />
        <SkeletonText widths={['w-28']} height="h-4" />
      </div>

      {/* Automatic Approval Checkbox Skeleton */}
      <div className="flex items-center space-x-2">
        <SkeletonRect width="w-4" height="h-4" rounded="sm" />
        <SkeletonText widths={['w-48']} height="h-4" />
      </div>

      {/* Repeatable Checkbox Skeleton */}
      <div className="flex items-center space-x-2">
        <SkeletonRect width="w-4" height="h-4" rounded="sm" />
        <SkeletonText widths={['w-56']} height="h-4" />
      </div>

      {/* Experience Points Input Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-40']} height="h-4" />
        </div>
        <SkeletonRect width="w-full" height="h-10" rounded="md" />
        <div className="mt-1">
          <SkeletonText widths={['w-64']} height="h-3" />
        </div>
      </div>

      {/* Tags Section Skeleton */}
      <div>
        <div className="mb-2">
          <SkeletonText widths={['w-16']} height="h-4" />
        </div>
        <div className="flex flex-wrap gap-2">
          <SkeletonPill width="w-20" height="h-8" />
          <SkeletonPill width="w-24" height="h-8" />
          <SkeletonPill width="w-16" height="h-8" />
        </div>
      </div>

      {/* Buttons Skeleton */}
      <div className="flex gap-3 mt-6">
        <SkeletonButton width="flex-1" height="h-10" rounded="md" />
        <SkeletonButton width="flex-1" height="h-10" rounded="md" />
      </div>
    </div>
  );
};

export default SubmissionFormFormSkeleton;
